class ProductColours extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els.title) return

    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()

    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)

    this.els.swatch.elements.forEach((swatch) => {
      this.listeners.add(swatch, 'mouseenter', this.handleMouseEnter)
      this.listeners.add(swatch, 'mouseleave', this.handleMouseLeave)
    })
  }

  handleMouseEnter (e) {
    this.els.title.element.textContent = e.currentTarget.dataset.colour
  }

  handleMouseLeave (e) {
    this.els.title.element.textContent =
      this.els.title.element.dataset.defaultColour
  }
}

customElements.define('product-colours', ProductColours)
